import { Pipe, PipeTransform } from '@angular/core';
import { reduceNortonProducts } from '@dch/products-business-logic';

@Pipe({
  name: 'aggregateNortonProducts',
})
export class AggregateNortonProductsPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return reduceNortonProducts(value);
  }
}
